import {Box, Tab, TabList, TabPanel, TabPanels, Tabs} from "@chakra-ui/react";
import {useRef} from "react";
import BellTable from "./Home/BellQueue";
import DevicesPanel from "./Devices/DevicesPanel";
import NextBellHero from "../../BellDashboard/components/NextBellHero";

const ControlTab = () => {
    const queueRef = useRef(null);

    const scrollToQueue = () => {
        queueRef.current?.scrollIntoView({behavior: "smooth", block: "start"});
    };

    return (
        <Box px={{base: 0, md: 2, xl: 4}} pt={0} pb={{base: 0, md: 2, xl: 4}} minW="0">
            <Tabs variant="enclosed" colorScheme="teal">
                <TabList>
                    <Tab>Home</Tab>
                    <Tab>Devices</Tab>
                    {/*<Tab>Announcements</Tab>*/}
                </TabList>

                <TabPanels>
                    <TabPanel px={{base: 0, md: 4}} py={{base: 3, md: 4}}>
                        <NextBellHero onSeeSchedule={scrollToQueue}/>
                        <Box ref={queueRef} mt={{base: 5, md: 6}}>
                            <BellTable/>
                        </Box>
                    </TabPanel>

                    <TabPanel px={{base: 0, md: 4}} py={{base: 3, md: 4}}>
                        <DevicesPanel/>
                    </TabPanel>

                    {/*<TabPanel>*/}
                    {/*    <Heading size="md">Announcements</Heading>*/}
                    {/*    <AnnouncementForm/>*/}
                    {/*</TabPanel>*/}
                </TabPanels>
            </Tabs>
        </Box>
    );
}

export default ControlTab;
